import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { Img } from 'utilities/components/img/component';

import cross from 'assets/images/cross.svg';

import './view.scss';

export const FiltersView = ({
    areFiltersVisible,
    areBadgesVisible,
    children,
    clearFilters,
    toggleFiltersVisibility
}) => (
    <div
        className={
            classnames('filters', {
                'filters--active': areFiltersVisible
            })
        }
    >
        <button
            className="filters__close"
            type="button"
            onClick={ () => {
                toggleFiltersVisibility();
            } }
        >
            <Img className="filters__icon" src={ cross } alt="iks" />
        </button>
        <div className="filters__container">
            <h4 className="filters__headline">Filtruj</h4>
            <button
                className="filters__show"
                type="button"
                onClick={ () => {
                    toggleFiltersVisibility();
                } }
            >
                Pokaż wyniki
            </button>
            {
                (areBadgesVisible)
                    && (
                        <button
                            className="filters__clear"
                            type="button"
                            onClick={ () => {
                                clearFilters();
                            } }
                        >
                            <span>Wyczyść filtry</span>
                        </button>
                    )
            }
        </div>
        { children }
    </div>
);

FiltersView.propTypes = {
    areFiltersVisible: PropTypes.bool.isRequired,
    areBadgesVisible: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
    clearFilters: PropTypes.func.isRequired,
    toggleFiltersVisibility: PropTypes.func.isRequired
};